import {Injectable} from '@angular/core';
import {
  TravelStyle,
  Icons, Theme,
  TravelPros,
  TravelSteps,
  SectionImage,
  PackageSearchResults
} from '../models/home/home.model';
import {Galery} from '../models/search-results.model';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/map';
import {SistemaService} from '../services/sistema/sistema.service';
import {Observable, of} from 'rxjs';
import travelstyles from '../json/travelstyles';

@Injectable({
  providedIn: 'root'
})
export class TravelStylesService {

  url: string;
  travelStyle: any[] = [];

  private readonly _tempKeyStorage = '__travelStyles';

  constructor(private http: HttpClient, private _sistemaService: SistemaService) {
    this.url = _sistemaService.url;
  }

  getTravelStyles(): Observable<any[]> {
    return of(travelstyles)
      .map(this.extractTravelStyles);
  }

  extractTravelStyles(res: any) {
    this.travelStyle = [];
    for (let i = 0; i < res.length; i++) {
      const tmp: any = {
        _id: res[i]._id,
        lemaxId: res[i].lemaxId,
        Permalink: res[i].Permalink,
        shortName: res[i].shortName,
        title: res[i].title,
        shortDescription: res[i].shortDescription,
        seoDescription: res[i].seoDescription,
        seoKeywords: res[i].seoKeywords,
        staticContentId: res[i].staticContentId,
        productDetailIcons: [],
        coverPhoto: res[i].coverPhoto.secure_url,
        s1slogan: res[i].s1slogan,
        s1landingCoverPhoto: res[i].s1landingCoverPhoto,
        s1buttonName: res[i].s1buttonName,
        s1buttonUrl: res[i].s1buttonUrl,
        s2title: res[i].s2title,
        s2text: res[i].s2text,
        s2icons: [],
        s3text: res[i].s3text,
        s3image: res[i].s3image,
        s4title: res[i].s4title,
        s4elements: [],
        s5title: res[i].s5title,
        s5description: res[i].s5description,
        s5themeGrid: [],
        s6title: res[i].s6title,
        s6description: res[i].s6description,
        s6buttonName: res[i].s6buttonName,
        s6buttonUrl: res[i].s6buttonUrl,
        s6image: res[i].s6image,
        s6BTitle: res[i].s6BTitle,
        s6BElements: [],
        s6BNote: res[i].s6BNote,
        s7title: res[i].s7title,
        s7recommendedForYou: [],
        socialCover: res[i].socialCover
      };
      if (res[i].productDetailIcons) {
        for (let j = 0; j < res[i].productDetailIcons.length; j++) {
          const productDetailIcons: any = {
            _id: res[i].productDetailIcons[j]._id,
            description: res[i].productDetailIcons[j].description,
            name: res[i].productDetailIcons[j].name,
            image: res[i].productDetailIcons[j].image.secure_url
          };
          tmp.productDetailIcons.push(productDetailIcons);
        }
      }
      if (res[i].s2icons) {
        for (let k = 0; k < res[i].s2icons.length; k++) {
          let s2icons: any = {
            _id: res[i].s2icons[k]._id,
            name: res[i].s2icons[k].name,
            description: res[i].s2icons[k].description,
            image: res[i].s2icons[k].image.secure_url
          };
          tmp.s2icons.push(s2icons);
        }
      }
      if (res[i].s5themeGrid) {
        for (let l = 0; l < res[i].s5themeGrid.length; l++) {
          let s5themeGrid: any = {
            _id: res[i].s5themeGrid[l]._id,
            name: res[i].s5themeGrid[l].name,
            lemaxId: res[i].s5themeGrid[l].lemaxId,
            cols: res[i].s5themeGrid[l].cols,
            rows: res[i].s5themeGrid[l].rows,
            coverPhotoHome: res[i].s5themeGrid[l].coverPhotoHome
          };
          tmp.s5themeGrid.push(s5themeGrid);
        }
      }
      if (res[i].s4elements) {
        for (let m = 0; m < res[i].s4elements.length; m++) {
          let s4elements: any = {
            _id: res[i].s4elements[m]._id,
            name: res[i].s4elements[m].name,
            description: res[i].s4elements[m].description,
            image: []
          };
          for (let o = 0; o < res[i].s4elements[m].image.length; o++) {
            let image: any = {
              secure_url: res[i].s4elements[m].image[o].secure_url,
              url: res[i].s4elements[m].image[o].url
            };
            s4elements.image.push(image);
          }
          tmp.s4elements.push(s4elements);
        }
      }
      if (res[i].s6BElements) {
        for (let n = 0; n < res[i].s6BElements.length; n++) {
          let s6BElements: any = {
            _id: res[i].s6BElements[n]._id,
            name: res[i].s6BElements[n].name,
            description: res[i].s6BElements[n].description,
            image: res[i].s6BElements[n].image.secure_url
          };
          tmp.s6BElements.push(s6BElements);
        }
      }
      if (res[i].s7recommendedForYou) {
        for (let p = 0; p < res[i].s7recommendedForYou.length; p++) {
          let s7recommendedForYou: PackageSearchResults = {
            TourTitle: res[i].s7recommendedForYou[p].TourTitle,
            TourID: res[i].s7recommendedForYou[p].TourID,
            Type: res[i].s7recommendedForYou[p].Type,
            DurationDD: res[i].s7recommendedForYou[p].DurationDD,
            DurationHR: res[i].s7recommendedForYou[p].DurationHR,
            MainTheme: res[i].s7recommendedForYou[p].MainTheme[0].MainThemeName,
            Countries: (res[i].s7recommendedForYou[p].Countries.length > 0) ? res[i].s7recommendedForYou[p].Countries[0].name : '',
            Mapa: res[i].s7recommendedForYou[p].Mapa,
            NumberOfCountries: res[i].s7recommendedForYou[p].NumberOfCountries,
            Style: res[i].s7recommendedForYou[p].Style,
            PriceInfo: res[i].s7recommendedForYou[p].PriceInfo,
            idCarousel: 0,
            Galery: []
          };
          for (let r = 0; r < res[i].s7recommendedForYou[p].Galery.length; r++) {
            let galery: Galery = {
              PhotoUrl: res[i].s7recommendedForYou[p].Galery[r].PhotoUrl,
              ThumbnailUrl: res[i].s7recommendedForYou[p].Galery[r].ThumbnailUrl,
              active: ''
            };
            s7recommendedForYou.Galery.push(galery);
          }
          tmp.s7recommendedForYou.push(s7recommendedForYou);
        }
      }
      this.travelStyle.push(tmp);
    }
    // console.log("this.travelStyle---->>>",this.travelStyle)
    return this.travelStyle;
  }

}
